import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Select, Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
import * as usg_action from 'actions/usage';
import toastr from 'helpers/toastr';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');

class BillSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      YYYY: [{ key: 'yyyy', value: 'yyyy', text: 'yyyy' }],
      MMDD: [{ key: 'mm-dd', value: 'mm-dd', text: 'mm-dd' }],
      vYYYY: props.yyyy,
      vMMDD: props.mmdd,
      invoiced: null
    };
  }
  componentWillMount() {
    this.dateSetting();
  }

  // 청구조회 날짜리스트 조회
  dateSetting = async () => {
    const { usageAPI, isLink } = this.props;
    const { vYYYY, vMMDD } = this.state;
    const yyyy = [];
    try {
      await usageAPI.billDateSel();
      const { billDateList } = this.props;
      let fYYYY = vYYYY;
      if (billDateList && billDateList.data) {
        const { invoiceds } = billDateList.data;
        invoiceds.forEach((item, idx) => {
          if (idx === 0) {
            fYYYY = item.yyyy;
          }
          const tempYYYY = isLink ? vYYYY : invoiceds[0].yyyy;
          yyyy.push({ key: item.yyyy, value: item.yyyy, text: item.yyyy });

          if (invoiceds.length === idx + 1) {
            this.setState({
              YYYY: yyyy,
              vYYYY: tempYYYY
            });
          }
        });
        //링크로 진입 시 해당 년도의 날짜 조회
        if (isLink) {
          this.mmddDateSetting(vYYYY);
          //첫번째 년도의 날짜 조회
        } else {
          this.mmddDateSetting(fYYYY);
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
        setTimeout(() => {
          this.context.router.history.push('/service/landing');
        }, 500);
      } else {
        console.log('##### dateSetting error: ', error);
      }
    }
  };

  //년 선택 시 해당 월 리스트 데이터 생성
  mmddDateSetting = (yyyy) => {
    const { billDateList, billGroupListSel, isLink } = this.props;
    const { vMMDD } = this.state;
    const temp = [];
    if (billDateList && billDateList.data) {
      const { invoiceds } = billDateList.data;
      invoiceds.some((item) => {
        if (item.yyyy === yyyy) {
          item.mmdd.forEach((mItem, idx) => {
            temp.push({ key: mItem, value: mItem, text: mItem });
            if (item.mmdd.length === idx + 1) {
              this.setState({
                MMDD: temp,
                vMMDD: isLink ? vMMDD : item.mmdd[0]
              });
              return true;
            }
          });
        }
      });
    }
    if (!isLink) {
      const { invoiceIdx } = this.props;
      this.billGroupListSel(invoiceIdx);
    }
  };

  // 날짜 선택
  dateChange = async (e, { name, value }) => {
    const { isLink } = this.props;
    if (!e.keyCode || e.keyCode === 13) {
      await this.setState({ [name]: value });
      if (name === 'vYYYY') {
        await this.mmddDateSetting(value);
      } else {
        this.billGroupListSel();
      }
    } else {
      return;
    }
  };

  billGroupListSel = (invoiceIdx) => {
    const { billGroupListSel, isLink } = this.props;
    const { vYYYY, vMMDD } = this.state;
    const params = {
      yyyy: vYYYY,
      mmdd: vMMDD
    };
    billGroupListSel(params, invoiceIdx);
  };

  // semantic ui 날짜 선택 시 변경 안되는 버그로 인한 함수 호출
  openDate = () => {
    setTimeout(() => {
      $($('#vMMDD').children()[0]).text(this.state.vMMDD);
    }, 5);
  };

  render() {
    var { YYYY, MMDD, vYYYY, vMMDD } = this.state;
    return (
      <ScForm>
        <ScSelectForm>
          <ScSelect placeholder="YYYY" name="vYYYY" options={YYYY} value={vYYYY} onChange={this.dateChange} />
          <ScSelect
            selection
            id="vMMDD"
            name="vMMDD"
            placeholder="MM-DD"
            options={MMDD}
            value={vMMDD}
            onOpen={this.openDate}
            onChange={this.dateChange}
          />
        </ScSelectForm>
      </ScForm>
    );
  }
}

const ScForm = styled.div`
  margin-bottom: 16px;
  position: relative;
`;
const ScSelectForm = styled.div``;
const ScSelect = styled(Select)`
  width: 80px;
  margin-right: 5px;
`;
const ScDropdown = styled(Dropdown)`
  &&&& {
    width: 120px;
    position: absolute;
  }
`;

BillSearchForm.contextTypes = {
  router: PropTypes.object.isRequired
};

BillSearchForm = connect(
  (state) => ({
    billDateList: state.usage.billDateList
  }),
  (dispatch) => ({
    usageAPI: bindActionCreators(
      {
        billDateSel: usg_action.BillDateList
      },
      dispatch
    )
  })
)(BillSearchForm);
export default BillSearchForm;
